import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background: linear-gradient(135deg, #722ed1 0%, #8b5cf6 100%);
  color: #ffffff;
  text-align: center;
  font-family: 'Roboto', sans-serif;
`;

export const ErrorCode = styled.h1`
  font-size: 10rem;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(45deg, #ffffff, #f3e8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: none;
  animation: glow 2s ease-in-out infinite alternate;

  @keyframes glow {
    from {
      filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.3));
    }
    to {
      filter: drop-shadow(0 0 30px rgba(255, 255, 255, 0.6));
    }
  }

  @media (max-width: 768px) {
    font-size: 6rem;
  }
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  margin: 1rem 0;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Description = styled.p`
  font-size: 1.2rem;
  margin: 1rem 0 3rem;
  max-width: 600px;
  line-height: 1.6;
  color: #f3e8ff;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin: 1rem 0 2rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

export const StyledButton = styled.button`
  background: #ffffff;
  color: #722ed1;
  border: 2px solid #ffffff;
  padding: 1rem 2.5rem;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

  &:hover {
    background: transparent;
    color: #ffffff;
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(-1px);
  }
`;

export const SecondaryButton = styled(StyledButton)`
  background: transparent;
  color: #ffffff;
  border-color: #ffffff;

  &:hover {
    background: #ffffff;
    color: #722ed1;
  }
`;

export const IconContainer = styled.div`
  font-size: 5rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  color: #f3e8ff;
  animation: float 3s ease-in-out infinite;

  @keyframes float {
    0%,
    100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-15px);
    }
  }
`;

export const BrandContainer = styled.div`
  margin-top: 3rem;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

export const BrandText = styled.p`
  font-size: 1rem;
  color: #f3e8ff;
  margin: 0;
  font-weight: 500;
`;

export const BrandLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;

  &:hover {
    color: #f3e8ff;
  }
`;
